import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const Root = styled(ContainerBase)`
  &.MuiContainer-root {
    margin: 35px auto 0;
    width: 100%;
  }
`

export const GridContainer = styled(({ height, margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    height: ${props => props.height};
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: bold;
  line-height: 32px;
  margin: 0;
  padding: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 0;
`

export const Info = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  text-align: right;
`

export const Link = styled('span')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  &:hover {
    text-decoration-line: underline;
  }
`

export const Ranking = styled('div')`
  align-items: center;
  background-color: transparent;
  color: ${props => props.theme.palette.brand.black1};
  display: flex;
  height: 32px;
  justify-content: center;
  margin: 0;
  max-width: 52px;
  width: 100%;

  &::after {
    content: '. º';
  }
`

export const Podium = styled(Ranking)`
  background-color: ${props => props.theme.palette.blue[90]};
  border-radius: 4px;
  color: ${props => props.theme.palette.brand.primary};

  &::after {
    color: ${props => props.theme.palette.brand.primary};
    content: '. º';
  }
`
